import ArrowIcon from './icons/ArrowIcon';
import BackIcon from './icons/BackIcon';
import CrossIcon from './icons/CrossIcon';
import MenuIcon from './icons/MenuIcon';
import SearchIcon from './icons/SearchIcon';

export default Object.freeze({
	arrow: ArrowIcon,
	search: SearchIcon,
	menu: MenuIcon,
	cross: CrossIcon,
	back: BackIcon
});
